import { BankIcon, Query } from "@/src/icons";
import { Card, Tooltip } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";

export const Balance = () => {
  const { balance, stakeBalance } = useBalances();
  return (
    <Card className="md:h-2/7 py-5">
      <div className="grid gap-3">
        <span className="flex items-center justify-between">
          <span className="flex items-center gap-2">
            
            <h2 className="text-2xl text-foreground font-semibold">CRB Balances</h2>
          </span>

          <div>
            
          </div>
        </span>

        <div>
          <p className="text-2xl md:text-3xl font-semibold text-foreground">
          {parseFloat(balance).toFixed(2)}
          </p>
          <h2 className="text-xl font-semibold text-foreground/50">CRB</h2>
        </div>
        <div>
          <p className="text-2xl md:text-3xl font-semibold text-foreground">
            {parseFloat(stakeBalance).toFixed(2)}
          </p>
          <h2 className="text-xl font-semibold text-foreground/50">
            Staked CRB
          </h2>
        </div>
      </div>
    </Card>
    
  );
};
